export const yearToNameFull = (value) => {
  if (value === -3) {
    return "EY1";
  } else if (value === -2) {
    return "EY2";
  } else if (value === -1) {
    return "NURSERY";
  } else if (value === 0) {
    return "RECEPTION";
  } else {
    return "YEAR " + value;
  }
};
export const yearsToNamesShort = (string) => {
  const parts = string.split(",");
  let returnString = "";
  parts.forEach((year) => {
    switch (year) {
      case "-3":
        returnString += "EY2";
        break;
      case "-2":
        returnString += "EY1";
        break;
      case "-1":
        returnString += "N";
        break;
      case "0":
        returnString += "R";
        break;
      default:
        returnString += year;
        break;
    }
    returnString += ",";
  });

  return returnString.slice(0, -1);
};
